<app-profile-loader
  *ngIf="isLoading"
  class="u-display-block"
></app-profile-loader>
<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="profileState | async as profile">
    <div *ngIf="userState | async as user" [@fadeInEnter]>
      <app-email-verification-banner
        *ngIf="!user.email_is_verified"
        [user]="user"
      ></app-email-verification-banner>
      <div class="bg-color-white mat-elevation-z1">
        <div
          class="u-margin-center"
          [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
        >
          <app-profile-intro
            class="u-paddingTop-32 u-display-block u-margin-center"
            [isUser]="isUser"
            [profile]="profile?.body"
            [tenantIceBreakers]="icebreakers"
            [user]="user"
          >
          </app-profile-intro>
        </div>
      </div>
      <div
        *ngIf="user.isAdmin && !isUser"
        fxShow.gt-sm="true"
        fxShow="false"
        [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
        class="u-margin-center u-paddingTop-16"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="32px" [ngStyle]="{ height: '24px' }">
            <mat-icon class="color-blue"> security</mat-icon>
          </div>
          <p
            i18n="@@profileView.adminEdit.permissionLabel"
            fxFlex="calc(100% - 32px)"
            class="color-grey"
          >
            You are able to edit this profile because you're an admin.
          </p>
        </div>
      </div>
      <div
        class="u-padding-24-0 u-margin-center"
        [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
      >
        <ng-container
          *ngIf="route.snapshot.queryParamMap.get('mode'); else profileHub"
        >
          <router-outlet></router-outlet>
        </ng-container>
        <ng-template #profileHub>
          <div
            fxLayout.gt-sm="row"
            *ngIf="!route.snapshot.queryParamMap.get('group')"
          >
            <div fxFlex.gt-sm="360px">
              <ng-container *ngIf="isUser && tenantState | async as tenant">
                <app-profile-completion-widget-view
                  class="u-display-block"
                  [group]="firstGroup"
                  [icebreakers]="icebreakers"
                  [tenant]="tenant"
                  [user]="user"
                >
                </app-profile-completion-widget-view>
              </ng-container>
              <div
                *ngIf="showSections.basicInfo"
                class="u-paddingBottom-16 u-borderBottom-grey100 u-marginBottom-16"
              >
                <app-profile-basic-info
                  class="bg-color-white u-padding-16 mat-elevation-z1 u-display-block"
                  [isUser]="isUser"
                  [profile]="profile?.body"
                  [tenant]="tenantState | async"
                  [user]="user"
                >
                </app-profile-basic-info>
              </div>
              <ng-container *ngIf="isUser">
                <app-profile-group-item
                  *ngFor="
                    let membership of profile?.body.groups | appVisibleGroups
                  "
                  class="bg-color-white mat-elevation-z1 u-marginBottom-16 u-display-block"
                  [group]="membership.document"
                  [isUser]="isUser"
                  [profile]="profile.body"
                  [user]="user"
                  [membership]="membership"
                >
                </app-profile-group-item>
                <app-profile-group-item
                  *ngFor="
                    let pendingMembership of profile?.body.pending_groups
                      | appVisibleGroups
                  "
                  class="bg-color-white mat-elevation-z1 u-marginBottom-16 u-display-block"
                  [group]="pendingMembership.document"
                  [profile]="profile.body"
                  [isUser]="isUser"
                  [user]="user"
                  [pendingMembership]="pendingMembership"
                  (pendingHub)="showPendingHubDialogue($event)"
                >
                </app-profile-group-item>
              </ng-container>
              <ng-container *ngIf="!isUser">
                <app-profile-group-item
                  *ngFor="
                    let membership of profile?.body.groups | appVisibleGroups
                  "
                  class="bg-color-white mat-elevation-z1 u-marginBottom-16 u-display-block"
                  [group]="membership.document"
                  [isUser]="isUser"
                  [membership]="membership"
                >
                </app-profile-group-item>
              </ng-container>
              <div
                *ngIf="opportunities?.length"
                class="u-borderTop-grey100 u-padding-16-0"
              >
                <app-profile-opportunities
                  [opportunities]="opportunities"
                  (getOpportunities)="
                    getAccountOpportunities(profile.body, user).subscribe()
                  "
                  [user]="user"
                  [totalCount]="opportunitiesTotalCount"
                  class="u-display-block bg-color-white mat-elevation-z1 u-marginBottom-16 u-display-block u-padding-16"
                >
                </app-profile-opportunities>
              </div>
            </div>
            <div
              fxFlex.gt-sm="calc(100% - 360px)"
              [ngClass.gt-sm]="'u-paddingLeft-24'"
            >
              <app-profile-icebreakers
                *ngIf="showSections.icebreakers"
                class="bg-color-white u-padding-16 mat-elevation-z1 u-marginBottom-16 u-display-block"
                [isUser]="isUser"
                [profile]="profile.body"
                [tenantIceBreakers]="icebreakers"
                [user]="user"
              ></app-profile-icebreakers>
              <app-profile-about
                *ngIf="showSections.about"
                class="bg-color-white u-padding-16 mat-elevation-z1 u-marginBottom-16 u-display-block"
                [profile]="profile.body"
                [user]="user"
                [isUser]="isUser"
              >
              </app-profile-about>
              <div
                *ngIf="
                  !showSections.icebreakers &&
                  !showSections.about &&
                  canBeMessaged &&
                  (tenantState | async)?.enabled_features?.conversations
                "
                class="u-padding-24 bg-color-white u-textAlign-center mat-elevation-z1"
              >
                <img
                  src="//storage.googleapis.com/ttc-static-images/waving-hand-sign_1f44b.png"
                  class="u-marginBottom-16"
                  [ngStyle]="{ width: '120px' }"
                  alt="Waving hand emoji"
                />
                <p
                  i18n="@@profileView.message.startConversation.label"
                  class="color-grey-300 u-marginBottom-16"
                >
                  Start a conversation with
                  {{ profile.body.first_name }}
                </p>
                <div class="u-textAlign-center">
                  <app-profile-action
                    [analyticName]="'profileView'"
                    [profile]="profile.body"
                    [user]="user"
                    class="u-display-block"
                  ></app-profile-action>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!!route.snapshot.queryParamMap.get('group')">
            <app-profile-more-info
              class="u-display-block u-width-100"
              [isUser]="isUser"
              [profile]="profile.body"
              [user]="user"
            >
            </app-profile-more-info>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </ng-container>
</ng-container>
